import {
  ExpandableSection,
  PremiumBreakdown,
  PremiumSummary,
  smBumps,
} from '@wrisk/ui-components'
import React, { FC, PropsWithChildren } from 'react'

import { Promotion } from '../../../../domain'
import { QuotePremiums } from '../../../../hooks/premiums'
import { TKeyBuilder } from '../../../../infrastructure/internationalisation'
import { IPT } from '../../product'
import { useStandardAdjustedPremium } from './hooks'

export interface StandardAdjustedPremiumProps extends PropsWithChildren {
  currentPremiums: QuotePremiums
  previousPremiums?: QuotePremiums
  promotion?: Promotion
  expanded?: boolean
  tKey: TKeyBuilder
  onExpansionChange?: (isExpanded: boolean) => void
}

export const StandardAdjustedPremium: FC<
  StandardAdjustedPremiumProps & {
    subheader?: string
  }
> = ({
  currentPremiums,
  previousPremiums,
  promotion,
  expanded,
  tKey,
  onExpansionChange,
  subheader,
  children,
}) => {
  const { currentAmount, previousAmount, header, lineItems, promo } =
    useStandardAdjustedPremium({
      currentPremiums,
      previousPremiums,
      promotion,
      tKey,
    })

  const headerEl = (
    <PremiumSummary
      header={header}
      subheader={subheader ?? promo}
      currentAmount={currentAmount}
      previousAmount={previousAmount}
    />
  )

  return (
    <ExpandableSection
      header={headerEl}
      open={expanded}
      reversed
      onChange={onExpansionChange}
    >
      {children ?? (
        <PremiumBreakdown
          lineItems={lineItems}
          ipt={<IPT amount={currentPremiums.totals.taxAmount} />}
          mx={smBumps}
        />
      )}
    </ExpandableSection>
  )
}
